import { connect } from 'react-redux';
import TinyGameStats from '../views/tiny/TinyGameStats';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({});

const TinyGameStatsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyGameStats);

export default TinyGameStatsContainer;


